<template>
    <div class="documentation">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb :title="$t('user_detail')" :breadcumb-data="breadcumbData"></Breadcumb>
            </div>
        </div>
        <div class="row cardcontainer" v-if="currentUser">
            <div class="col-xl-12">
                <b-card no-body class="mb-4">
                    <b-card-body>
                        <div class="media">
                            <div class="media-body pt-2 ml-3">
                                <h5 class="mb-2">{{ currentUser.userprofile.lastname }} {{ currentUser.userprofile.firstname }}</h5>
                                <div class="text-muted small">
                                    <template v-if="$cookie.get('language') == 'fr'">{{ currentUser.userprofile.user_type.label }}</template>
                                    <template v-if="$cookie.get('language') == 'en'">{{ currentUser.userprofile.user_type.label_en }}</template
                                ></div>
                            </div>
                        </div>
                    </b-card-body>
                    <hr class="border-light m-0">
                    <b-card-body>
                        <div class="mb-2">
                            <span class="text-muted">{{ $t('email')}}:</span>&nbsp;
                            {{ currentUser.email }}
                        </div>
                        <div class="mb-2">
                            <span class="text-muted">{{ $t('company')}} :</span>&nbsp;
                            <ul>
                                <li v-for="company in currentUser.userprofile.related_companies">{{ company.name }}</li>
                            </ul>
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<script>
    import Breadcumb from '../components/breadcumb';
    import { mapState } from 'vuex';
    import Multiselect from 'vue-multiselect'
    import {ADMIN_USER_DETAIL_REQUEST} from "../_store/administration/user/actiontypes";

    export default {
        name: 'adminCategoryAdd',
        // eslint-disable-next-line vue/no-unused-components
        components: {Breadcumb, },
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('users_list'), href: '/users/list/'},
                { text: this.$t('user_detail'), active: true},

            ]
            this.$store.dispatch(ADMIN_USER_DETAIL_REQUEST, { id : this.$route.params.id})
                .then(result => {
                    this.currentUser = result.data.user;
                    if (this.tags.length === 0){
                        this.tags = result.data.user.userprofile.tags.map(tag => {
                            return {
                                id: tag.id,
                                label: tag.label
                            }
                        })
                    }
                })
        },
        computed: mapState({
            errors: state => state.admin_user.errors,
            user: state => state.user.user
        }),
        data() {
            return ({
                breadcumbData: [],
                tagData: [{
                    language: 'Tags Utilisateur',
                    libs: []
                }],
                tags: [],
                currentUser: false
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
        }
    };
</script>
